import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CopyBlock, dracula } from "react-code-blocks";
import { useWhitelabel } from "../../context/WhitelabelContext";

interface APIKeyDialogProps {
  open: boolean;
  onClose: () => void;
  apiKey: string;
}

export default function APIKeyDialog({ open, onClose, apiKey }: APIKeyDialogProps) {
  const { whitelabelSettings } = useWhitelabel();
  
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {whitelabelSettings?.title || "GTM AI"} API Key
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Use the following API key for authenticating with {whitelabelSettings?.title || "GTM AI"}.
        </Typography>
        <Box sx={{ mt: 2, mb: 2 }}>
          <CopyBlock
            language="javascript"
            text={apiKey}
            wrapLines
            codeBlock
            showLineNumbers={false}
            theme={dracula}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}